/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* --- Claude fix (see assets/theme.css ~line 11111) ---
   A stray custom rule, ".Product__Wrapper .Product__Tabs{ opacity:0 !important; height: 0px !important; }",
   force-hides the Benefits / Key Ingredients / How To Use / FAQs product accordion on desktop & tablet.
   This injects a small stylesheet that overrides it. Safe to remove once that rule is deleted directly
   from assets/theme.css. */
(function () {
  var style = document.createElement('style');
  style.setAttribute('data-claude-fix', 'product-tabs-visibility');
  style.textContent = '.Product__Wrapper .Product__Tabs{opacity:1 !important;height:auto !important;}';
  document.head.appendChild(style);
})();
